import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NeoExpansionModule } from '@neogov/pattern-library/neo-expansion-panel';

@Component({
  selector: 'cm-accordion',
  standalone: true,
  imports: [CommonModule, NeoExpansionModule],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent {}
